// @flow
export const ANIMATION_KEY_IMPLODE = 'implode';
export const ANIMATION_KEY_SLIDE = 'slide';
export const ANIMATION_SLIDE_ENTER_DURATION = 1000;
export const ANIMATION_SLIDE_EXIT_DURATION = 1000;
export const ANIMATION_IMPLODE_DURATION = 250;



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-block/constants.js